import * as assert from 'assert';
import { ProxyCorsService } from '../Services/CorsService';

const ANONYMOUS = 'Anonymous';

export async function compressImage(imageSource: any, targetWidth: number, rotation?: number): Promise<File> {
    const format = 'image/jpeg';
    const img = new Image();

    img.crossOrigin = ANONYMOUS;
    let rotatedSource: string | undefined = undefined;
    if (rotation) {
        const [uri] = await rotateImage(imageSource, rotation, true);
        rotatedSource = uri;
    }

    return new Promise<File>(resolve => {
        img.onload = () => {
            const { width, height } = img;

            const scalingFactor = width / targetWidth;

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = targetWidth;
            canvas.height = height / scalingFactor;

            ctx!.drawImage(img, 0, 0, targetWidth, height / scalingFactor);

            const scaled = canvas.toDataURL(format);
            const uri = dataUriToBlob(scaled, format);

            resolve(new File([uri], `thumbnail`, { type: `image/jpeg` }));
        };

        img.src = rotatedSource || imageSource;
    });
}

function dataUriToBlob(dataUri: string, format: string): Blob {
    const binary = atob(dataUri.split(',')[1]);
    const array: Array<number> = [];
    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: format });
}

export function rotateImage(imageSource: string, rotation: number, isFromUpload?: boolean): Promise<[string, Blob]> {
    const format = 'image/jpeg';
    const img = new Image();

    img.crossOrigin = ANONYMOUS;

    rotation = rotation % 360;
    assert(rotation >= 0 && rotation % 90 === 0, `Rotation: (${rotation}) needs to be on an even 90 degree basis`);

    return new Promise(resolve => {
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const contex = canvas.getContext('2d')!;
            const isReflection = rotation === 0 || rotation === 180;

            canvas.height = isReflection ? img.height : img.width;
            canvas.width = isReflection ? img.width : img.height;

            contex.clearRect(0, 0, img.height, img.width);
            contex.save();
            contex.translate(canvas.width / 2, canvas.height / 2);
            contex.rotate((rotation * Math.PI) / 180);

            contex!.drawImage(img, -img.width / 2, -img.height / 2);

            const scaled = canvas.toDataURL(format);
            const blob = dataUriToBlob(scaled, format);

            resolve([URL.createObjectURL(blob), blob]);
        };

        const service = new ProxyCorsService('');
        img.src = isFromUpload ? imageSource : service.getCorsUrlProxy(imageSource);
    });
}

export function getRotatedFileFromImage(imageSource: string, rotation: number): Promise<File> {
    const format = 'image/jpeg';
    const img = new Image();

    img.crossOrigin = ANONYMOUS;

    assert(
        rotation === 0 || rotation === 90 || rotation === 180 || rotation === 270 || rotation === 360,
        `Rotation: (${rotation}) needs to be on an even 90 degree basis`,
    );

    return new Promise<File>(resolve => {
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const contex = canvas.getContext('2d')!;
            const isReflection = rotation === 0 || rotation === 180;

            canvas.height = isReflection ? img.height : img.width;
            canvas.width = isReflection ? img.width : img.height;

            contex.clearRect(0, 0, img.height, img.width);
            contex.save();
            contex.translate(canvas.width / 2, canvas.height / 2);
            contex.rotate((rotation * Math.PI) / 180);

            contex.drawImage(img, -img.width / 2, -img.height / 2);

            const scaled = canvas.toDataURL(format);
            const uri = dataUriToBlob(scaled, format);

            resolve(new File([uri], 'full_image'));
        };

        img.src = imageSource;
    });
}

export function getNextRotation(degrees: number): number {
    const nextRotation = degrees + 90;
    return nextRotation >= 360 ? 0 : nextRotation;
}



// WEBPACK FOOTER //
// ./src/util/resizeImage.ts